import { MetadataFieldDefinition } from '../generated-api';

/**
 * System metadata fields that are always available for all games.
 * These fields are automatically included in all play sessions.
 */
export const SYSTEM_METADATA_FIELDS: MetadataFieldDefinition[] = [
  {
    name: 'score',
    displayName: 'Score',
    type: 'number',
    options: null,
    icon: 'trophy',
    isSystemField: true
  },
  {
    name: 'startingPosition',
    displayName: 'Starting Position',
    type: 'order',
    options: null,
    icon: 'mapPin',
    isSystemField: true
  },
  {
    name: 'playerNotes',
    displayName: 'Player Notes',
    type: 'text',
    options: null,
    icon: 'documentText',
    isSystemField: true
  },
  {
    name: 'totalTurnDuration',
    displayName: 'Total Turn Duration (seconds)',
    type: 'number',
    options: null,
    icon: 'clock',
    isSystemField: true
  }
];

/**
 * Helper function to merge system fields with game-defined fields.
 * System fields are always included first, followed by game-defined fields.
 */
export const getAllMetadataFields = (gameFields: MetadataFieldDefinition[] = []): MetadataFieldDefinition[] => {
  return [...SYSTEM_METADATA_FIELDS, ...gameFields];
};

